import React from 'react';
import { Col } from 'reactstrap';

import TransportationOrder from './TransportationOrder';
import { WhitePanel, Prices } from '../../../components';

export default function TransportationSummary(props) {
  const { invoice, lineItems, promocodeResponse, children } = props;

  let { rate, discount, amount } = invoice;

  if (promocodeResponse) {
    const { promocodeAmount, purchaseAmount, totalAmount } = promocodeResponse;

    rate = purchaseAmount;
    discount = promocodeAmount;
    amount = totalAmount;
  }

  return (
    <Col lg="6" className="trek-summary">
      <WhitePanel>
        <h2>Transportation Summary</h2>
        {lineItems.map(lineItem => (
          <TransportationOrder
            key={lineItem.id}
            order={lineItem}
            currency={invoice.currency}
          />
        ))}
        <Prices
          discount={discount}
          basePrice={rate}
          grandTotal={amount}
          currency={invoice.currency}
        />
        {children}
      </WhitePanel>
    </Col>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Transportation/Common/TransportationSummary.js